import { Grid, GridProps } from '@tq/ui-components';
import React from 'react';
import { ToggleButtonProps } from '../ToggleButton';

export interface ToggleButtonGroupProps extends GridProps {
  value: string | number;
  children: React.ReactElement<ToggleButtonProps>[];
}
export const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({
  children,
  value,
  ...gridProps
}) => {
  const buttons = React.Children.map(children, (child) =>
    React.cloneElement(child, { ...child.props, active: child.props.value === value })
  );

  return (
    <Grid gridAutoColumns='1fr' gridAutoFlow='column' width='100%' {...gridProps}>
      {buttons}
    </Grid>
  );
};
